// extracted by mini-css-extract-plugin
export default {"root":"MachineCard_root__Twb9S","plantName":"MachineCard_plantName__d8DjV"};